import PropTypes from 'prop-types'
/* eslint camelcase: 0 */
import React from 'react'
import moment from 'moment'
import { FormattedDate, FormattedMessage } from 'react-intl'
import Button from 'components/util/Button'
import styles from './_suggestedGoal.css'

export default function SuggestedGoal ({ goal, userId }) {
  const startDate = moment().add(1, 'weeks').startOf('week').toDate()

  const {
    body: {
      data_type_field,
      value,
    },
  } = goal

  const setGoalHref = `/profile/${userId}/goals/create/?data_type_field=${data_type_field}&target=${value}`

  return (
    <div className={styles.suggestedGoalContainer}>
      <div className={styles.goalInfo}>
        <div className={styles.goalName}>
          {goal.name}
        </div>
        <div className={styles.goalDesc}>
          {goal.description}
        </div>
        <div className={styles.startDate}>
          <FormattedMessage
            id='suggestedgoal.startdate'
            defaultMessage='Starts on {startDate}'
            values={{
              startDate: <FormattedDate value={startDate} />,
            }} />
        </div>
      </div>
      <a className={styles.setGoalButton} href={setGoalHref}>
        <Button
          el='button'
          type='primary'
          size='large'>
          <FormattedMessage
            id='suggestedgoal.set'
            defaultMessage='Set Goal' />
        </Button>
      </a>
    </div>
  )
}

SuggestedGoal.propTypes = {
  goal: PropTypes.object,
  userId: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/goals/view/SuggestedGoal.jsx